import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/lp-logo-black.png'


const _withScopeId = n => (_pushScopeId("data-v-4b7a01a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Love on people logo"
  })
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "navbar-nav" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_scroll_detection = _resolveDirective("scroll-detection")!

  return _withDirectives((_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-lg", 
      'lp-' +
      _ctx.mode +
      ' ' +
      (_ctx.hasBackground ? 'has-background' : '') +
      ' ' +
      (_ctx.expanded ? 'expanded' : '')
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        onClick: _ctx.toggleNavbar,
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarNav",
        "aria-controls": "navbarNav",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, _hoisted_5, 8, _hoisted_3),
      _createElementVNode("div", {
        class: _normalizeClass(["collapse navbar-collapse", _ctx.expanded ? 'show' : 'hide']),
        id: "navbarNav"
      }, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode("HOME")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/about"
            }, {
              default: _withCtx(() => [
                _createTextVNode("ABOUT")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/projects"
            }, {
              default: _withCtx(() => [
                _createTextVNode("PROJECTS")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/volunteering"
            }, {
              default: _withCtx(() => [
                _createTextVNode("VOLUNTEERING")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/donate"
            }, {
              default: _withCtx(() => [
                _createTextVNode("DONATE")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/contact"
            }, {
              default: _withCtx(() => [
                _createTextVNode("CONTACT")
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ])
  ], 2)), [
    [_directive_scroll_detection, { upClass: 'scroll-up', downClass: 'scroll-down' }]
  ])
}